import { Observable, of } from "rxjs";
import { Injectable } from "@angular/core";

export abstract class SuggestionsSearchProvider {
  // this is the query to be used when nothing is known about user intentions
  // hence we just search the db for most popular terms - whatever they are.
  public abstract searchForMostPopular(): Observable<any>;

  // this is a method to use when user types in one or  more characters. we assume
  // those characters represent 'value' without being bound to specific 'category'
  // the query should return most popular 'values' in all 'categories'.
  // if acceptedCategories array is provided, then those values should be searched within given categories.
  public abstract searchForSuggestions(term: string, acceptedCategories: string[]): Observable<any>;

  // this is a query to use when 'category' is known. If term is not given, we shall
  // return most popular 'values' within that 'category'. If term is given,
  // then top N matching 'values' within 'category' will be returned.
  public abstract searchForSuggestionsInCategory(category:string, term?: string): Observable<any>;
}
